import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 298.878 298.878"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M252.439 0h-206a7.5 7.5 0 0 0-7.5 7.5v34.333c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5V15h88v268.878H123.48a7.5 7.5 0 0 0-7.5 7.5 7.5 7.5 0 0 0 7.5 7.5h51.918a7.5 7.5 0 0 0 7.5-7.5 7.5 7.5 0 0 0-7.5-7.5h-18.459V15h88v26.833a7.5 7.5 0 0 0 7.5 7.5 7.5 7.5 0 0 0 7.5-7.5V7.5a7.5 7.5 0 0 0-7.5-7.5" }, null, -1)
  ])))
}
export default { render: render }